module.exports = __webpack_public_path__ + "img/category-skill-game.840ca227.png";